import type { KeywordsTrafficSource } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { IKeywordsFilterDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateObjectValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

export default class FindKeywordsFilter extends FilterPanelBaseFilter<
    IKeywordsFilterDto,
    readonly KeywordsTrafficSource[]
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IKeywordsFilterDto, readonly KeywordsTrafficSource[]>) {
        super(deps);
    }

    calculateValueDelta(
        previousValue: IKeywordsFilterDto | undefined,
        newValue: IKeywordsFilterDto | undefined,
    ): FilterValueDelta<IKeywordsFilterDto> {
        return calculateObjectValueDelta(previousValue, newValue);
    }

    isValueEmpty(value: IKeywordsFilterDto): boolean {
        return !value?.keyword;
    }
}
